module.exports = "## Table\n\n[Tables](https://www.google.com/design/spec/components/data-tables.html)\nare used to display data and to organize it.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Table/README.md
 ** module id = 1071
 ** module chunks = 0
 **/